<canvas #canvasEl [width]="width" [height]="height" (click)="draw()" class=""></canvas>